if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


function clickAnchor() {
    var location_hash = location.hash;
    const hash_top = $(location_hash).offset().top;
    $('html,body').animate({ scrollTop: hash_top - 100 }, 1200);
}

$(document).ready(function () {
    $(".various").fancybox({
        maxWidth: 970,
        maxHeight: 600,
        fitToView: false,
        width: '70%',
        height: '70%',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none'
    });
});

(function () {

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick();


    function loadSpecialsbyTag(container, selectVal, callback = false) {
        fetch(`${site_url}ajax/functions.php?operation=getSpecialsByTag&special_tag=` + selectVal, { method: "GET" })
            .then((resp) => resp.json())
            .then((data) => {
                container.innerHTML = data.html;
                $(".fancybox").fancybox();
                if (callback != false) {
                    callback();
                }
            });
        }
        
    let specials = window.location.href;
    let linkSpecialsGolf = "https://www.temeculacreekinn.com/temecula-hotel-packages#Golf";
    
    const specials_container = document.querySelector('.specials-container');

    if (specials_container) {

        if(window.location.href === 'https://www.temeculacreekinn.com/temecula-hotel-packages#Golf'){
            loadSpecialsbyTag(specials_container, 'golf', function () {
                // clickAnchor();
                console.log("specials loadded");
                if($("[data-tag='Golf']").length > 0){
                        $(`[data-tag='Golf']`).click();
                        $(`[data-tag='all']`).removeClass("active");
                        $(`[data-tag='Golf']`).addClass("active");
                        console.log('con #Golf');
                    setTimeout(() => {
                    $('html, body').animate({ scrollTop: $('#moduleFilter').offset().top - 200 }, 1000);
                               
                    }, 500);
                }
            });
        }else{
            loadSpecialsbyTag(specials_container, 'all', function () {
                // clickAnchor();
                console.log("specials loadded");
                if($("[data-tag='Golf']").length > 0){
                        $(`[data-tag='all']`).click();
                        console.log('no #Golf');
                    setTimeout(() => {
                    $('html, body').animate({ scrollTop: $('#moduleFilter').offset().top - 200 }, 1000);
                               
                    }, 500);
                }
            });
        }

        
    }


    

    const window_height = window.innerHeight;
    let animatedEl = document.getElementsByClassName('animate-fade-2');
    for (let i = 0; i < animatedEl.length; i++) {
        var viewportOffset = animatedEl[i].getBoundingClientRect();
        let topPos = viewportOffset.top;
        if (topPos <= window_height * 0.8) {
            animatedEl[i].classList.add('fade-in');
        }
    }


    const special_links = document.querySelectorAll('.specials-nav a');
    const specials_lengt = special_links.length;
    for (let i = 0; i < specials_lengt; i++) {
        special_links[i].addEventListener('click', function () {
            const this_tag = this.dataset.tag;
            for (let l = 0; l < specials_lengt; l++) {
                special_links[l].classList.remove('active');
            }
            this.classList.add('active');
            loadSpecialsbyTag(specials_container, this_tag);
        })
    }

    $('.tags-list a').click(function () {
        const thisTag = $(this).attr('data-tag');
        $('.grid--filter .grid__col').hide();
        $('.grid--filter .' + thisTag).fadeIn();
        $('.tags-list a').removeClass('active');
        $(this).addClass('active');
    })

})();


$('.slide-caring').slick({
    arrows: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 500,
    fade: false,
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});

$('.top-slider').slick({
    arrows: false,
    dots: false, 
    autoplay: true,
    autoplaySpeed: 6000, 
    speed: 500, 
    fade: true, 
    accessibility: false,
    pauseOnHover: false
});

